export const RIGHT_DOCK_WIDTH = 550;
export const RIGHT_DOCK_TRIGGER_WIDTH = 48;
export const RIGHT_DOCK_TOP = 60;
